import { useEffect, useState } from "react"
import { useUser } from "../Context"
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../Firebase";

export default function Reports() {
    const { user, loading, setLoading } = useUser();
    // const [start, setStart] = useState()
    // const [end, setEnd] = useState()
    const [start, setStart] = useState('2024-04-01')
    const [end, setEnd] = useState('2025-03-31')
    const navigate = useNavigate();
    const [reportsGenerated, setReportsGenerated] = useState(false);
    const [openingLeaseBalances, setOpeningLeaseBalances] = useState(0)
    const [openingROU, setOpeningROU] = useState(0)
    const [prepaidRent, setPrepaidRent] = useState(0)
    const [securityDeposit, setSecurityDeposit] = useState(0)
    const [aggDepreciation, setAggDepreciation] = useState(0);
    const [aggPayment, setAggPayment] = useState();
    const [aggInterestIncome, setAggInterestIncome] = useState(0);
    const [earlyTermClose,setEarlyTermClose]=useState(0)
    const [aggInterestExpense, setAggInterestExpense] = useState(0);
    const [decimalPlaces, setDecimalPlaces] = useState(2)
    const [openPropertyROU, setOpenPropertyROU] = useState(0)
    const [openVehicleROU, setOpenVehicleROU] = useState(0)
    const [openEquipmentROU, setOpenEquipmentROU] = useState(0)
    const [closePropertyROU, setClosePropertyROU] = useState(0)
    const [closeVehicleROU, setCloseVehicleROU] = useState(0)
    const [closeEquipmentROU, setCloseEquipmentROU] = useState(0)
    const [openCurrentLease, setOpenCurrentLease] = useState(0)
    const [closeCurrentLease, setCloseCurrentLease] = useState(0)
    const [openNonCurrentLease, setOpenNonCurrentLease] = useState(0)
    const [closeNonCurrentLease, setCloseNonCurrentLease] = useState(0)

    useEffect(() => {
        if (user?.leaseList?.length === 0) {
            toast("Enter some data first.");
            navigate('/add-lease');
        }
    }, [user])

    // function handleReportRange() {
    //     if (!start || !end) {
    //         toast.warn("Please select a range.");
    //         return;
    //     }
    //     console.log("Loading set to true");
    //     setLoading(true);
    //     try {
    //         user.leaseList.forEach(async (element) => {
    //             const leaseDoc = await getDoc(doc(db, "lease", element));
    //             if (leaseDoc.exists()) {
    //                 let lease = leaseDoc.data();
    //                 if (((lease.startDate >= start && lease.startDate <= end) ||
    //                     (lease.endDate >= start && lease.endDate <= end) ||
    //                     (lease.startDate <= start && lease.endDate >= end)) && lease.openingLeaseLiability) {
    //                     setOpeningLeaseBalances((prev) => prev + lease.openingLeaseLiability)
    //                     // console.log(lease.openingLeaseLiability);
    //                 }
    //             }
    //             const ammortizationDoc = await getDoc(doc(db, 'ammortization', element));
    //             if (ammortizationDoc.exists()) {
    //                 let ammortization = ammortizationDoc.data().data;
    //                 const filteredAmmortization = ammortization.filter((item) => { return item.month <= end && item.month >= start })
    //                 // console.log(filteredAmmortization);
    //                 filteredAmmortization.forEach((item) => {
    //                     // console.log(aggDepreciation);
    //                     setAggDepreciation((prev) => prev + item?.depreciation)
    //                     setAggInterestExpense((prev) => prev + item.monthlyInterest)
    //                     setAggInterestIncome((prev) => prev + item?.interestIncome)
    //                 })
    //                 // }
    //             }
    //         })
    //     }
    //     catch (error) {
    //         console.log(error);
    //     }
    //     setReportsGenerated(true);
    //     console.log("Loading set to false");
    //     setLoading(false);
    // }

    function getPreviousMonth(inputDate) {
        const [year, month] = inputDate.split('-').map(Number);
        const prevMonthYear = month === 1 ? year - 1 : year;
        const prevMonthMonth = month === 1 ? 12 : month - 1;
        const result = `${prevMonthYear}-${String(prevMonthMonth).padStart(2, '0')}`;
        return result;
    }

    async function handleReportRange() {
        setEarlyTermClose(0)
        setOpeningLeaseBalances(0)
        setOpenCurrentLease(0)
        setCloseCurrentLease(0)
        setOpenNonCurrentLease(0)
        setCloseNonCurrentLease(0)
        setOpenEquipmentROU(0)
        setOpenPropertyROU(0)
        setOpenVehicleROU(0)
        setCloseEquipmentROU(0)
        setClosePropertyROU(0)
        setCloseVehicleROU(0)
        setOpeningROU(0)
        setPrepaidRent(0)
        setSecurityDeposit(0)
        setAggDepreciation(0)
        setAggInterestExpense(0)
        setAggPayment(0)
        setAggInterestIncome(0)
        setReportsGenerated(false)
        if (!start || !end) {
            toast.warn("Please select a range.");
            return;
        }
        // console.log("Loading set to true");
        setLoading(true);
        try {
            await Promise.all(user.leaseList.map(async (element) => {
                let assetType;
                const leaseDoc = await getDoc(doc(db, "lease", element));
                if (leaseDoc.exists()) {
                    let lease = leaseDoc.data();
                    assetType = lease.type;
                    if (
                        // (
                        (lease.startDate >= start && lease.startDate <= end)
                        // ||
                        //     (lease.endDate >= start && lease.endDate <= end) ||
                        //     (lease.startDate <= start && lease.endDate >= end)) 
                        && lease.openingLeaseLiability) {
                        setPrepaidRent((prev) => prev + lease.prepaidRent)
                        setOpeningROU((prev) => prev + lease.openingROUAsset)
                        setSecurityDeposit((prev) => prev + parseInt(lease.securityDeposit))
                        setOpeningLeaseBalances((prev) => prev + lease.openingLeaseLiability)
                    }
                }

                const ammortizationDoc = await getDoc(doc(db, 'ammortization', element));
                if (ammortizationDoc.exists()) {
                    let ammortization = ammortizationDoc.data().data;
                    const filteredAmmortization = ammortization.filter((item) => { return item.month <= end && item.month >= start });
                    filteredAmmortization.forEach((item) => {
                        setAggDepreciation((prev) => prev + item?.depreciation);
                        setAggInterestExpense((prev) => prev + item.monthlyInterest);
                        setAggInterestIncome((prev) => prev + item?.interestIncome);
                        setAggPayment((prev) => prev + item?.payment)
                    });
                    const startInput = getPreviousMonth(start.slice(0, 7));
                    const endInput = end.slice(0, 7);
                    // console.log(endInput);
                    const startAmmortization = ammortization.filter((item) => item.month.slice(0, 7) === startInput)
                    const endAmmortization = ammortization.filter((item) => item.month.slice(0, 7) === endInput)
                    // console.log("Start is: ",startAmmortization)
                    // console.log("End is: ",endAmmortization)
                    if (endAmmortization.length > 0) {
                        console.log(leaseDoc.data())
                        if(leaseDoc.data().earlyTermination){
                            setEarlyTermClose((prev) => prev + endAmmortization[0].closingBalance)
                        }
                        else{
                            setCloseNonCurrentLease((prev) => prev + endAmmortization[0].closingBalance)
                        }
                        setOpenNonCurrentLease((prev) => prev + endAmmortization[0].openingLeaseLiability)
                    }
                    if (startAmmortization.length > 0) {
                        setCloseCurrentLease((prev) => prev + startAmmortization[0].closingBalance)
                        setOpenCurrentLease((prev) => prev + startAmmortization[0].closingBalance)
                    }
                    if (assetType === 'equiment') {
                        if (startAmmortization.length > 0) {
                            setOpenEquipmentROU((prev) => prev + startAmmortization[0].ROUAsset)
                        }
                        if (endAmmortization.length > 0) {
                            setCloseEquipmentROU((prev) => prev + endAmmortization[0].closingRou)
                        }
                    }
                    else if (assetType === 'vehicle') {
                        if (startAmmortization.length > 0) {
                            setOpenVehicleROU((prev) => prev + startAmmortization[0].ROUAsset)
                        }
                        if (endAmmortization.length > 0) {
                            setCloseVehicleROU((prev) => prev + endAmmortization[0].closingRou)
                        }
                    }
                    else if (assetType === 'property') {
                        if (startAmmortization.length > 0) {
                            setOpenPropertyROU((prev) => prev + startAmmortization[0].ROUAsset)
                        }
                        if (endAmmortization.length > 0) {
                            setClosePropertyROU((prev) => prev + endAmmortization[0].closingRou)
                        }
                    }
                }
            }));
        } catch (error) {
            console.log(error);
        }
        setReportsGenerated(true);
        setStart()
        setEnd()
        console.log("Loading set to false");
        setLoading(false);
    }


    const handleIncreaseDecimalPlaces = () => {
        if (decimalPlaces < 6) {
            setDecimalPlaces(prevValue => prevValue + 1);
        } else {
            toast.warn("Decimal places cannot exceed 6");
        }
    };

    const handleDecreaseDecimalPlaces = () => {
        if (decimalPlaces > 0) {
            setDecimalPlaces(prevValue => prevValue - 1);
        } else {
            toast.warn("Decimal places cannot be less than 0");
        }
    };

    return (
        <>
            {loading ? <Loading /> :
                <main className="w-screen h-auto p-8">
                    <div className="px-8 flex flex-col gap-4">
                        <h2 className="text-2xl font-medium w-fit antialiased text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text" >Enter duration for which reports are to be generated:</h2>
                        <div className="flex w-3/5 gap-6">
                            <div className="flex gap-2 items-center w-1/2 border transition-all duration-200 focus-within:shadow-md hover:shadow-md px-4 h-12 rounded-xl">
                                <h3 className="flex-shrink-0 text-blue-500 text-lg" >From :</h3>
                                <input className="w-full  outline-none h-full" max={end} onChange={(e) => { setStart(e.target.value) }} type="date" />
                            </div>
                            <div className="flex gap-2 items-center w-1/2 border transition-all duration-200 focus-within:shadow-md hover:shadow-md px-4 h-12 rounded-xl">
                                <h3 className="flex-shrink-0 text-blue-500 text-lg" >To :</h3>
                                <input className="w-full outline-none h-full" min={start} onChange={(e) => { setEnd(e.target.value) }} type="date" />
                            </div>
                            <button onClick={() => { handleReportRange() }} className="px-3 py-1 text-lg rounded border hover:bg-sky-500 hover:shadow-md hover:text-white transition-all duration-200">Generate</button>
                        </div>
                    </div>
                    {reportsGenerated &&
                        <div>
                            <div className="p-8 flex flex-col gap-3">
                                <div className="flex items-center w-full justify-between pr-2">
                                    <h2 className="text-2xl font-medium w-fit antialiased text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text" >Carrying Amount: </h2>
                                    <div className="flex items-center gap-3 text-gray-600">
                                        Round off to
                                        <div className="border rounded-md overflow-hidden">
                                            <button className="aspect-square w-10 bg-sky-500 text-white invert-1 transition-all duration-200 hover:bg-sky-600 text-lg" onClick={handleDecreaseDecimalPlaces}>-</button>
                                            <input className="h-full w-10 outline-none text-center" type="number" value={decimalPlaces} readOnly />
                                            <button className="aspect-square w-10 bg-sky-500 text-white invert-1 transition-all duration-200 hover:bg-sky-600 text-lg" onClick={handleIncreaseDecimalPlaces}>+</button>
                                        </div>
                                        decimal places
                                    </div>
                                </div>
                                <div className="grid grid-flow-row grid-cols-1">
                                    <div className="report-row  bg-sky-500 sticky top-20">
                                        <p className="col-span-8 border border-gray-50 h-full py-2 px-4 text-xl font-medium text-white" >Particulars</p>
                                        <p className="col-span-2 border border-gray-50 h-full py-2 px-4 text-xl font-medium text-white" >Opening Balance</p>
                                        <p className="col-span-2 border border-gray-50 h-full py-2 px-4 text-xl font-medium text-white" >Closing Balance</p>
                                    </div>
                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Right to Use asset
                                            </h2>
                                            <p className="report-debit">
                                                {/* ₹ {openingROU.toFixed(decimalPlaces)} */}
                                            </p>
                                            <p className="report-credit">
                                                {/* ₹ {ROU.toFixed(decimalPlaces)} */}
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                Property
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {openPropertyROU.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                                ₹ {closePropertyROU.toFixed(decimalPlaces)}
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                Vehicle
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {openVehicleROU.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                                ₹ {closeVehicleROU.toFixed(decimalPlaces)}
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                Equipment
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {openEquipmentROU.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                                ₹ {closeEquipmentROU.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Lease Liabilities
                                            </h2>
                                            <p className="report-debit">
                                                {/* ₹ {securityDeposit.toFixed(decimalPlaces)} */}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                Current
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {(openCurrentLease - openNonCurrentLease).toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                                ₹ {(openCurrentLease - closeNonCurrentLease).toFixed(decimalPlaces)}
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                Non-current
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {(openNonCurrentLease).toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                                ₹ {(closeNonCurrentLease - (openCurrentLease - closeNonCurrentLease)).toFixed(decimalPlaces)}
                                            </p>
                                        </div>


                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                Total
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {(openCurrentLease).toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                                ₹ {(closeNonCurrentLease).toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div className="p-8 flex flex-col gap-3">
                                <div className="flex items-center w-full justify-between pr-2">
                                    <h2 className="text-2xl font-medium w-fit antialiased text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text" >Lease Liability Movement: </h2>
                                    <div className="flex items-center gap-3 text-gray-600">
                                        Round off to
                                        <div className="border rounded-md overflow-hidden">
                                            <button className="aspect-square w-10 bg-sky-500 text-white invert-1 transition-all duration-200 hover:bg-sky-600 text-lg" onClick={handleDecreaseDecimalPlaces}>-</button>
                                            <input className="h-full w-10 outline-none text-center" type="number" value={decimalPlaces} readOnly />
                                            <button className="aspect-square w-10 bg-sky-500 text-white invert-1 transition-all duration-200 hover:bg-sky-600 text-lg" onClick={handleIncreaseDecimalPlaces}>+</button>
                                        </div>
                                        decimal places
                                    </div>
                                </div>
                                <div className="grid grid-flow-row grid-cols-1">
                                    <div className="report-row  bg-sky-500 sticky top-20">
                                        <p className="col-span-9 border border-gray-50 h-full py-2 px-4 text-xl font-medium text-white" >Description</p>
                                        <p className="col-span-3 border border-gray-50 h-full py-2 px-4 text-xl font-medium text-white" >Amount (in ₹)</p>
                                    </div>
                                    <div className="report-div">

                                        <div className="report-row2">
                                            <h2 className="report-heading2">
                                                Lease Liability
                                            </h2>
                                            <p className="report-debit2">
                                                {/* ₹ {openingROU.toFixed(decimalPlaces)} */}
                                            </p>
                                        </div>

                                        <div className="report-row2">
                                            <h2 className="report-heading2 pl-16">
                                                At the beginning of the period
                                            </h2>
                                            <p className="report-debit2">
                                                ₹ {(openCurrentLease).toFixed(decimalPlaces)}
                                            </p>
                                        </div>

                                        <div className="report-row2">
                                            <h2 className="report-heading2 pl-16">
                                                Lease Liability created during the year
                                            </h2>
                                            <p className="report-debit2">
                                                ₹ {(openingLeaseBalances).toFixed(decimalPlaces)}
                                            </p>
                                        </div>


                                        <div className="report-row2">
                                            <h2 className="report-heading2 pl-16">
                                                Interest
                                            </h2>
                                            <p className="report-debit2">
                                                ₹ {(aggInterestExpense).toFixed(decimalPlaces)}
                                            </p>
                                        </div>

                                        <div className="report-row2">
                                            <h2 className="report-heading2 pl-16">
                                                Shutdown Adjustment
                                            </h2>
                                            <p className="report-debit2">
                                                ₹ {(earlyTermClose).toFixed(decimalPlaces)}
                                            </p>
                                        </div>


                                        <div className="report-row2">
                                            <h2 className="report-heading2 pl-16">
                                                Payment
                                            </h2>
                                            <p className="report-debit2">
                                                ₹ {(aggPayment).toFixed(decimalPlaces)}
                                            </p>
                                        </div>


                                        <div className="report-row2">
                                            <h2 className="report-heading2 pl-16">
                                                At the end of the period
                                            </h2>
                                            <p className="report-debit2">
                                                ₹ {(openCurrentLease + openingLeaseBalances + aggInterestExpense -earlyTermClose -aggPayment).toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>

                                    {/* <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Depreciation on Right to Use assets
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {aggDepreciation.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To accumulated depreciation on Right to Use assets
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                ₹ {aggDepreciation.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Interest expense
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {aggInterestExpense.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To lease liability
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                ₹ {aggInterestExpense.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Lease liability
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {openingROU.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To Right to Use asset
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                ₹ {openingROU.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Security deposit
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {aggInterestIncome.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To Interest on unwinding of security deposit
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                ₹ {aggInterestIncome.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>
                                     */}
                                </div>
                            </div>

                            <div className="p-8 flex flex-col gap-3">
                                <div className="flex items-center w-full justify-between pr-2">
                                    <h2 className="text-2xl font-medium w-fit antialiased text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text" >Journal entries: </h2>
                                    <div className="flex items-center gap-3 text-gray-600">
                                        Round off to
                                        <div className="border rounded-md overflow-hidden">
                                            <button className="aspect-square w-10 bg-sky-500 text-white invert-1 transition-all duration-200 hover:bg-sky-600 text-lg" onClick={handleDecreaseDecimalPlaces}>-</button>
                                            <input className="h-full w-10 outline-none text-center" type="number" value={decimalPlaces} readOnly />
                                            <button className="aspect-square w-10 bg-sky-500 text-white invert-1 transition-all duration-200 hover:bg-sky-600 text-lg" onClick={handleIncreaseDecimalPlaces}>+</button>
                                        </div>
                                        decimal places
                                    </div>
                                </div>
                                <div className="grid grid-flow-row grid-cols-1">
                                    <div className="report-row  bg-sky-500 sticky top-20">
                                        <p className="col-span-8 border border-gray-50 h-full py-2 px-4 text-xl font-medium text-white" >Accounts</p>
                                        <p className="col-span-2 border border-gray-50 h-full py-2 px-4 text-xl font-medium text-white" >Debit</p>
                                        <p className="col-span-2 border border-gray-50 h-full py-2 px-4 text-xl font-medium text-white" >Credit</p>
                                    </div>
                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Opening Right to Use asset
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {openingROU.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To lease liability
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                ₹ {openingLeaseBalances.toFixed(decimalPlaces)}
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To Prepaid Rent
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                ₹ {prepaidRent.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Security Deposit
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {securityDeposit.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To Bank
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                ₹ {securityDeposit.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Depreciation on Right to Use assets
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {aggDepreciation.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To accumulated depreciation on Right to Use assets
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                ₹ {aggDepreciation.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Interest Expense
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {aggInterestExpense.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To Lease Liability
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                ₹ {aggInterestExpense.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Right to Use asset
                                            </h2>
                                            <p className="report-debit">
                                                {/* ₹ {openingROU.toFixed(decimalPlaces)} */}
                                                ₹ {openingLeaseBalances.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To Lease liability
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                {/* ₹ {openingROU.toFixed(decimalPlaces)} */}
                                                ₹ {openingLeaseBalances.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>


                                    <div className="report-div">

                                        <div className="report-row">
                                            <h2 className="report-heading">
                                                Security Deposit
                                            </h2>
                                            <p className="report-debit">
                                                ₹ {aggInterestIncome.toFixed(decimalPlaces)}
                                            </p>
                                            <p className="report-credit">
                                            </p>
                                        </div>

                                        <div className="report-row">
                                            <h2 className="report-heading pl-16">
                                                To Interest on unwinding of security deposit
                                            </h2>
                                            <p className="report-debit">
                                            </p>
                                            <p className="report-credit">
                                                ₹ {aggInterestIncome.toFixed(decimalPlaces)}
                                            </p>
                                        </div>
                                    </div>


                                    {/* <div className="report-div">

                                    <div className="report-row">
                                        <h2 className="report-heading">
                                            Lease liability
                                        </h2>
                                        <p className="report-debit">
                                            ₹ {aggInterestExpense.toFixed(decimalPlaces)}
                                        </p>
                                        <p className="report-credit">
                                        </p>
                                    </div>

                                    <div className="report-row">
                                        <h2 className="report-heading pl-16">
                                            To lease liability
                                        </h2>
                                        <p className="report-debit">
                                        </p>
                                        <p className="report-credit">
                                            ₹ {aggInterestExpense.toFixed(decimalPlaces)}
                                        </p>
                                    </div>
                                </div> */}


                                    {/* <div className="report-div">
                                    <h2 className="report-heading">
                                        Prepaid Rent in the period:
                                    </h2>
                                    <p className="report-debit">
                                        ₹ {prepaidRent.toFixed(decimalPlaces)}
                                    </p>
                                    <p className="report-credit">

                                    </p>
                                </div>
                                <div className="report-div">
                                    <h2 className="report-heading">
                                        Security Deposit in the period:
                                    </h2>
                                    <p className="report-debit">
                                        ₹ {securityDeposit.toFixed(decimalPlaces)}
                                    </p>
                                    <p className="report-credit">

                                    </p>
                                </div>
                                <div className="report-div">
                                    <h2 className="report-heading">
                                        Opening lease balances:
                                    </h2>
                                    <p className="report-debit">
                                        ₹ {openingLeaseBalances.toFixed(decimalPlaces)}
                                    </p>
                                    <p className="report-credit">

                                    </p>
                                </div>
                                <div className="report-div">
                                    <h2 className="report-heading">
                                        Depreciation in the period:
                                    </h2>
                                    <p className="report-debit">
                                        ₹ {aggDepreciation.toFixed(decimalPlaces)}
                                    </p>
                                    <p className="report-credit">

                                    </p>
                                </div>
                                <div className="report-div">
                                    <h2 className="report-heading">
                                        Interest Expense in the period:
                                    </h2>
                                    <p className="report-debit">
                                        ₹ {aggInterestExpense.toFixed(decimalPlaces)}
                                    </p>
                                    <p className="report-credit">

                                    </p>
                                </div>
                                <div className="report-div">
                                    <h2 className="report-heading">
                                        Interest Income in the period:
                                    </h2>
                                    <p className="report-debit">
                                        ₹ {aggInterestIncome.toFixed(decimalPlaces)}
                                    </p>
                                    <p className="report-credit">

                                    </p>
                                </div> */}
                                </div>
                            </div>
                        </div>
                    }
                </main>
            }
        </>
    )
}